import React from 'react';
import ReactDOM from 'react-dom';

import defaultPicture from '../images/contact-default.png';

export default class MakingCall extends React.Component {
  constructor(props) {
    super(props);
    this.defaultPicture = defaultPicture;
    this.state = { callStarted: false };
    this.cancelCall = this.cancelCall.bind(this);
  }

  componentWillMount() {
    window.MakingCall = this;
  }

  componentWillUnmount() {
    delete window.MakingCall;
    if (this.state.callStarted) this.audio.pause();
  }

  async startCall() {
    this.setState({ callStarted: true });
    this.audio = new Audio(await import('../sounds/calling.mp3'));
    this.audio.loop = true;
    this.audio.play();
  }

  cancelCall() {
    if (this.state.callStarted) this.props.socket.emit('cancel-call', { email: this.props.email });
    ReactDOM.unmountComponentAtNode(document.getElementById('makingCall'));
  }

  render() {
    const locale = global.dictionaries.calling;

    return (
      <div className="modal is-active">
        <div className="modal-background" />
        <div className="modal-content">
          <div className="contact-card">
            <img
              src={this.props.picture || this.defaultPicture}
              className="image"
              alt={this.props.name}
            />
            <p className="name">{this.props.name}</p>
            <hr />
            <p className="call-button">
              <span className="icon">
                <i className="fa fa-circle-o-notch fa-spin" />
              </span>
              &nbsp;
              <span style={{ textTransform: 'capitalize' }}>{locale.make} ...</span>
            </p>
            <p className="cancel-button" onClick={this.cancelCall}>
              <span className="icon">
                <i className="fa fa-times" />
              </span>
              &nbsp;
              <span style={{ textTransform: 'capitalize' }}>{locale.cancel} ...</span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MakingCall.js